import { nodeIdentity } from "@lattice-php/core/test-id";
import type { RendererComponent } from "@lattice-php/core/types";
import { Progress } from "./progress";

export const ProgressAdapter: RendererComponent<"progress"> = ({ node }) => (
  <Progress
    className={node.props.class ?? undefined}
    color={node.props.color}
    data-test={nodeIdentity(node)}
    max={node.props.max}
    shape={node.props.shape}
    showValue={node.props.showValue}
    size={node.props.size}
    value={node.props.value}
  />
);
